"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichContext = void 0;
const react_1 = require("react");
exports.EnrichContext = (0, react_1.createContext)(null);
